//#region DevExtreme Imports

import 'devextreme/ui/toolbar'
import 'devextreme/ui/form'

//#endregion

import { IIMRCashierPanelSendNotificationController } from "./cashier-panel-send-notification.controller"

import { USER_SESSION_SERVICE_NAME } from "../../../../services/user-session"
import { $SCOPE_SERVICE_NAME } from "../../../../services/system"

//#region Asset Imports

import * as TEMPLATE from './cashier-panel-send-notification.tpl.html'
import './cashier-panel-send-notification.scss'

//#endregion

export const COMPONENT_NAME: string = 'imrCashierPanelSendNotification'

export class IMRCashierPanelSendNotificationComponent implements ng.IComponentOptions {
    controller = [
        $SCOPE_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,

        IIMRCashierPanelSendNotificationController
    ]

    bindings = {
        options: '<'
    } as { [index: string]: string }

    template = TEMPLATE
}
